export const CREATE_BANK_PAYMENT  = 'CREATE_BANK_PAYMENT';
export const GET_BANK_PAYMENTS  = 'GET_BANK_PAYMENTS';
export const BANK_PAYMENT_REQUEST  = 'BANK_PAYMENT_REQUEST';
export const DELETE_BANK_PAYMENT  = 'DELETE_BANK_PAYMENT';
export const UPDATE_BANK_PAYMENT  = 'UPDATE_BANK_PAYMENT';
export const BANK_PAYMENT_REQUEST_SUCCESS  = 'BANK_PAYMENT_REQUEST_SUCCESS';
export const BANK_PAYMENT_REQUEST_FAILURE  = 'BANK_PAYMENT_REQUEST_FAILURE';
export const GET_BANK_PAYMENTS_PAGE  = 'GET_BANK_PAYMENTS_PAGE';